import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { selectProductsPageUserSettings } from '../../store/products-page/products-page.selectors';
import { tap, take } from 'rxjs/operators';
import { ProductsPageActions } from '../../store/products-page';

@Injectable({
  providedIn: 'root'
})
export class ProductPreferencesResolver implements Resolve<Observable<boolean>> {
  private readonly versionFlag = '4.1.3';

  constructor(private store: Store) {}

  resolve(): Observable<boolean> {
    this.store
      .select(selectProductsPageUserSettings)
      .pipe(
        take(1),
        tap((settings) => {
          if (!settings) {
            this.store.dispatch(ProductsPageActions.getUserSettings({ versionFlag: this.versionFlag }));
          }
        })
      )
      .subscribe();
    return of(true);
  }
}
